
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6397"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6397"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3ueMA", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $289fa3fab82a0cd6$export$6503ec6e8aabbaf; }, function (v) { return $289fa3fab82a0cd6$export$6503ec6e8aabbaf = v; });
var $289fa3fab82a0cd6$export$6503ec6e8aabbaf;
var $289fa3fab82a0cd6$export$f7ad0328861e2f03;
"use strict";
var $289fa3fab82a0cd6$var$mapping = new Map();
function $289fa3fab82a0cd6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$289fa3fab82a0cd6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $289fa3fab82a0cd6$var$resolve(id) {
    var resolved = $289fa3fab82a0cd6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$289fa3fab82a0cd6$export$6503ec6e8aabbaf = $289fa3fab82a0cd6$var$register;
$289fa3fab82a0cd6$export$f7ad0328861e2f03 = $289fa3fab82a0cd6$var$resolve;

});

parcelRegister("1VgMz", function(module, exports) {
document.querySelector(".btn.btn-hamburger").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.remove("hide");
});
document.querySelector(".btn.navigationDrawer--closeBtn").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.add("hide");
});
document.querySelectorAll('[data-element="navItem-expander"]').forEach((el)=>{
    el.querySelector(".navigationDrawer--navItemBtn").addEventListener("click", (e)=>{
        if (el.querySelector(".navigationDrawer--navItemExpanded").classList.contains("hide")) {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.remove("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "180deg";
        } else {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.add("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "0deg";
        }
    });
});

});

parcelRegister("eZzoa", function(module, exports) {
const $aea236adfe947986$var$btnTopNavigationEls = document.querySelectorAll(".btn.link-item");
const $aea236adfe947986$var$navigationMegaDropdownEl = document.querySelector(".navigationMegaDropdown");






const $aea236adfe947986$var$setValueDropDownNavigation = (keyElement)=>{
    const dropdownNavigation = {
        services: [
            {
                pageUrl: "intelligent-finance.html",
                logoSrc: new URL((parcelRequire("dEKS9"))),
                title: "Intelligent Finance Function"
            },
            {
                pageUrl: "manage-payroll.html",
                logoSrc: new URL((parcelRequire("1ICF9"))),
                title: "Managed Payroll"
            },
            {
                pageUrl: "consulting.html",
                logoSrc: new URL((parcelRequire("62f2s"))),
                title: "Consulting"
            }
        ],
        products: [
            {
                pageUrl: "people-management.html",
                logoSrc: new URL((parcelRequire("7QJiP"))),
                title: "People Management"
            },
            {
                pageUrl: "power-insight.html",
                logoSrc: new URL((parcelRequire("7EaWj"))),
                title: "Power Insight"
            },
            {
                pageUrl: "all-product.html",
                logoSrc: new URL((parcelRequire("lXlin"))),
                title: "All Product"
            }
        ]
    };
    $aea236adfe947986$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn").forEach((el, index)=>index > 0 && el.remove());
    dropdownNavigation[keyElement].forEach((value)=>{
        const navigationMegaDropdownBtn = $aea236adfe947986$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdownBtn").cloneNode(true);
        navigationMegaDropdownBtn.href = value.pageUrl;
        navigationMegaDropdownBtn.querySelector('[data-element="logoNavigation"]').src = value.logoSrc;
        navigationMegaDropdownBtn.querySelector('[data-element="titleNavigation"]').textContent = value.title;
        $aea236adfe947986$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdown--inner").appendChild(navigationMegaDropdownBtn);
    });
    $aea236adfe947986$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn")[0].remove();
};
$aea236adfe947986$var$btnTopNavigationEls.forEach((el)=>{
    el.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "flex";
        $aea236adfe947986$var$setValueDropDownNavigation(el.getAttribute("data-element"));
    });
    el.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "none";
    });
    $aea236adfe947986$var$navigationMegaDropdownEl.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "flex";
    });
    $aea236adfe947986$var$navigationMegaDropdownEl.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $aea236adfe947986$var$navigationMegaDropdownEl.style.display = "none";
    });
});

});
parcelRegister("dEKS9", function(module, exports) {
module.exports = new URL("battery-charging.ba1b1745.webp", import.meta.url).toString();

});

parcelRegister("1ICF9", function(module, exports) {
module.exports = new URL("settings-02.d69d69bd.webp", import.meta.url).toString();

});

parcelRegister("62f2s", function(module, exports) {
module.exports = new URL("life-buoy.285e728c.webp", import.meta.url).toString();

});

parcelRegister("7QJiP", function(module, exports) {
module.exports = new URL("people.d532b8d6.webp", import.meta.url).toString();

});

parcelRegister("7EaWj", function(module, exports) {
module.exports = new URL("grid.f0e29351.webp", import.meta.url).toString();

});

parcelRegister("lXlin", function(module, exports) {
module.exports = new URL("box.2a34708a.webp", import.meta.url).toString();

});


parcelRegister("lAems", function(module, exports) {

var $g1prE = parcelRequire("g1prE");
const $fb68199a103da584$var$testimonialCardParent = document.querySelector(".swiper-wrapper.testimonial-cards");
(0, $g1prE.default).forEach((testimonial)=>{
    const testimonialCardEl = document.querySelector('[data-element="testimonial-card-slider"]').cloneNode(true);
    testimonialCardEl.querySelector('[data-element="testimonial-people-name"]').textContent = testimonial.name;
    testimonialCardEl.querySelector('[data-element="testimonial-position"]').textContent = testimonial.position;
    testimonialCardEl.querySelector('[data-element="testimonial-text-all"]').innerHTML = testimonial.testimonyTextAll;
    testimonialCardEl.querySelector('[data-element="testimonial-text-less"]').innerHTML = testimonial.testimonyTextLess ?? testimonial.testimonyText;
    testimonialCardEl.querySelector('[data-element="testimonial-company-logo"]').src = testimonial.companyLogo;
    testimonialCardEl.querySelector('[data-element="testimonial-company-logo"]').parentElement.classList.add(testimonial.companyLogoClass);
    testimonialCardEl.querySelector('[data-element="testimonial-photo-small"]').srcset = testimonial.photo.mobile;
    testimonialCardEl.querySelector('[data-element="testimonial-photo-large"]').src = testimonial.photo.desktop;
    $fb68199a103da584$var$testimonialCardParent.appendChild(testimonialCardEl);
});
document.querySelectorAll('[data-element="testimonial-card-slider"]')[0].remove();
document.querySelectorAll(".testimonial-content .showMoreBtn").forEach((el)=>{
    el.addEventListener("click", ()=>{
        const testimonialContent = el.parentElement.parentElement;
        testimonialContent.querySelector('[data-element="testimonial-text-all"]').style.display = "inline";
        testimonialContent.querySelector('[data-element="testimonial-text-less"]').style.display = "none";
    });
});
document.querySelectorAll(".testimonial-content .showLessBtn").forEach((el)=>{
    el.addEventListener("click", ()=>{
        const testimonialContent = el.parentElement.parentElement;
        testimonialContent.querySelector('[data-element="testimonial-text-all"]').style.display = "none";
        testimonialContent.querySelector('[data-element="testimonial-text-less"]').style.display = "inline";
    });
});

});
parcelRegister("g1prE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baa07a2da563b7cf$export$2e2bcd8739ae039; });




























const $baa07a2da563b7cf$var$testimonials = [
    {
        name: "Neo Christodoulou",
        photo: {
            mobile: new URL((parcelRequire("7HH6J"))),
            tablet: new URL((parcelRequire("fQXxj"))),
            desktop: new URL((parcelRequire("fQXxj")))
        },
        position: "Founder, Smashing Plates",
        companyLogo: new URL((parcelRequire("3xrfP"))),
        companyLogoClass: "smashing-plates",
        testimonyText: "Wenodo have been a long-standing close partner. Their holistic approach in managing our accounts has been invaluable to our organization. Not only do they handle all of our accounting needs, but they also expertly manage our HR/payroll department and also their customized cloud-based real-time analytics and reports has provided us with valuable insights and data-driven decision-making."
    },
    {
        name: "Johnny Smith and Daniel Willis",
        photo: {
            mobile: new URL((parcelRequire("aNEv1"))),
            tablet: new URL((parcelRequire("eEPT9"))),
            desktop: new URL((parcelRequire("eEPT9")))
        },
        position: "Co Founder, Luca Restaurant",
        companyLogo: new URL((parcelRequire("iTpqM"))),
        companyLogoClass: "luca",
        testimonyText: "Wenodo's team is exceptional! Their profound knowledge of the hospitality industry and their friendly customer service have been invaluable to our business. Their expertise in the intricacies of our industry coupled with their approachable and supportive service have made working with them a true pleasure. They understand our needs and offer tailored solutions, making a significant difference in our operations."
    },
    {
        name: "Wonchul Park",
        photo: {
            mobile: new URL((parcelRequire("5UGtP"))),
            tablet: new URL((parcelRequire("jB2T7"))),
            desktop: new URL((parcelRequire("jB2T7")))
        },
        position: "Michelin Star Chef, Sollip",
        companyLogo: new URL((parcelRequire("6Owqq"))),
        companyLogoClass: "sollip",
        testimonyText: "Wenodo have been a long-standing close partner. Their holistic approach in managing our accounts has been invaluable to our organization. Not only do they handle all of our accounting needs, but they also expertly manage our HR/payroll department and also their customized cloud-based real-time analytics and reports has provided us with valuable insights and data-driven decision-making."
    },
    {
        name: "George\xa0Kakavitsa",
        photo: {
            mobile: new URL((parcelRequire("esJeA"))),
            tablet: new URL((parcelRequire("9096f"))),
            desktop: new URL((parcelRequire("9096f")))
        },
        position: "Assistant Restaurant Manager, L\xedo London",
        companyLogo: new URL((parcelRequire("iNJPw"))),
        companyLogoClass: "lio",
        testimonyText: "Wenodo's HR/Rota SaaS solution has revolutionized our workforce management. Its intuitive interface simplifies employee's lifecycle, shift scheduling and communication. With robust reporting, we gain valuable insights for informed decisions. Exceptional customer support ensures smooth operations. It's a game-changer for our Restaurant operation, enhancing efficiency and employee engagement. Highly recommended!"
    },
    {
        name: "Dominic Hamdy",
        photo: {
            mobile: new URL((parcelRequire("7fLN9"))),
            tablet: new URL((parcelRequire("3Kl3R"))),
            desktop: new URL((parcelRequire("3Kl3R")))
        },
        position: "Founder, HAM Restaurants",
        companyLogo: new URL((parcelRequire("7DE1Y"))),
        companyLogoClass: "ham",
        testimonyText: "WENODO has helped to grow and streamline our business from day one. We can now make financial and strategic decisions based on data we can trust. Their personal attitude and enthusiasm to go the extra mile is invaluable, but it's their modern approach to accounting that has \xa0propelled us forward.\xa0"
    },
    // {
    //   name: 'Tarek Farah',
    //   photo: {
    //     mobile: new URL('../image/testimonial-tarek-farah-mobile.png?as=webp', import.meta.url),
    //     tablet: new URL('../image/testimonial-tarek-farah.png?as=webp', import.meta.url),
    //     desktop: new URL('../image/testimonial-tarek-farah.png?as=webp', import.meta.url)
    //   },
    //   position: 'Founder and CEO, Aline Lebanese Kitchen',
    //   companyLogo: new URL(
    //     '../image/aline-company.png',
    //     import.meta.url
    //   ),
    //   companyLogoClass: 'aline',
    //   testimonyText: 'I have been gladly working with the Wenodo team for nearly 10 years. They are not just professional, experienced, and knowledgeable accountants but also great consultants who offer so much value and advice on all levels of hospitality. I cannot imagine any of our future projects being developed without Wenodo by our side!'
    // },
    {
        name: "David Bellaiche",
        photo: {
            mobile: new URL((parcelRequire("8Ixig"))),
            tablet: new URL((parcelRequire("8usPw"))),
            desktop: new URL((parcelRequire("8usPw")))
        },
        position: "Co-Founder, NAC London",
        companyLogo: new URL((parcelRequire("jvVwZ"))),
        companyLogoClass: "nac",
        testimonyText: "Wenodo's daily, weekly, and monthly KPIs and analytics has been so critical for our business. Their insightful Dashboard and reports have allowed us to maximize profits. With these detailed metrics, we're empowered to make timely and informed decisions, contributing significantly to\xa0our\xa0success."
    },
    {
        name: "Gabriel Cohen-Elia",
        photo: {
            mobile: new URL((parcelRequire("jmWdC"))),
            tablet: new URL((parcelRequire("4UIas"))),
            desktop: new URL((parcelRequire("4UIas")))
        },
        position: "Co-Founder, Cr\xe8me London",
        companyLogo: new URL((parcelRequire("030vB"))),
        companyLogoClass: "creme",
        testimonyText: "Partnering with Wenodo has revolutionized how we manage our finances and operations. Their specialized accounting and bookkeeping solutions have not only streamlined our processes but also brought unparalleled clarity to our financial landscape. Wenodo's dedicated support team is always responsive and knowledgeable, making them an integral part of our success. For anyone in hospitality seeking reliability and expertise, Wenodo is the\xa0clear\xa0choice."
    }
];
var $baa07a2da563b7cf$export$2e2bcd8739ae039 = $baa07a2da563b7cf$var$testimonials;

});
parcelRegister("7HH6J", function(module, exports) {
module.exports = new URL("testimoni-neo-mobile.63e4b5d3.webp", import.meta.url).toString();

});

parcelRegister("fQXxj", function(module, exports) {
module.exports = new URL("testimoni-neo.dcffeccd.webp", import.meta.url).toString();

});

parcelRegister("3xrfP", function(module, exports) {
module.exports = new URL("smashing-plates.7136aa41.webp", import.meta.url).toString();

});

parcelRegister("aNEv1", function(module, exports) {
module.exports = new URL("testimoni-johny-mobile.dfee8b00.webp", import.meta.url).toString();

});

parcelRegister("eEPT9", function(module, exports) {
module.exports = new URL("testimoni-johny.331dada6.webp", import.meta.url).toString();

});

parcelRegister("iTpqM", function(module, exports) {
module.exports = new URL("luca-company.ebbca258.webp", import.meta.url).toString();

});

parcelRegister("5UGtP", function(module, exports) {
module.exports = new URL("testimonial-wonchul-mobile.82623782.webp", import.meta.url).toString();

});

parcelRegister("jB2T7", function(module, exports) {
module.exports = new URL("testimonial-wonchul.e435ed72.webp", import.meta.url).toString();

});

parcelRegister("6Owqq", function(module, exports) {
module.exports = new URL("sollip-company.c4e68d8a.png", import.meta.url).toString();

});

parcelRegister("esJeA", function(module, exports) {
module.exports = new URL("testimonial-george-mobile.ba4357c1.webp", import.meta.url).toString();

});

parcelRegister("9096f", function(module, exports) {
module.exports = new URL("testimonial-george.3f5b8295.webp", import.meta.url).toString();

});

parcelRegister("iNJPw", function(module, exports) {
module.exports = new URL("lio-company.51d21251.png", import.meta.url).toString();

});

parcelRegister("7fLN9", function(module, exports) {
module.exports = new URL("testimonial-dominic-hamdy-mobile.795bc261.webp", import.meta.url).toString();

});

parcelRegister("3Kl3R", function(module, exports) {
module.exports = new URL("testimonial-dominic-hamdy.7a029c2b.webp", import.meta.url).toString();

});

parcelRegister("7DE1Y", function(module, exports) {
module.exports = new URL("ham-company.5f8ce858.png", import.meta.url).toString();

});

parcelRegister("8Ixig", function(module, exports) {
module.exports = new URL("testimonial-david-bellaiche-mobile.c3669d3d.webp", import.meta.url).toString();

});

parcelRegister("8usPw", function(module, exports) {
module.exports = new URL("testimonial-david-bellaiche.e487dcaf.webp", import.meta.url).toString();

});

parcelRegister("jvVwZ", function(module, exports) {
module.exports = new URL("nac-company.269e0029.png", import.meta.url).toString();

});

parcelRegister("jmWdC", function(module, exports) {
module.exports = new URL("testimonial-gabriel-mobile.45a97971.webp", import.meta.url).toString();

});

parcelRegister("4UIas", function(module, exports) {
module.exports = new URL("testimonial-gabriel.ad41ee07.webp", import.meta.url).toString();

});

parcelRegister("030vB", function(module, exports) {
module.exports = new URL("creme-company.ca71e074.png", import.meta.url).toString();

});



parcelRegister("j1fKb", function(module, exports) {
const $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl = document.querySelector(".preferencePrivacy-popup");
const $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl = document.querySelector(".preferencePrivacy-popupDetail");
const $dd8a52bd9dba4c43$var$isCookies = document.cookie.split(";").filter((value)=>value === "_cookies=guest")[0] === "_cookies=guest" || document.cookie.split(";").filter((value)=>value === " _cookies=guest")[0] === " _cookies=guest";
if ($dd8a52bd9dba4c43$var$isCookies) $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
else $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.add("show");
// Cookies Button
document.querySelector(".btn-cookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.add("show");
// document.querySelector('.cookies-alert-popup').style.display = 'block'
});
document.querySelector(".cookies-accept-btn").addEventListener("click", ()=>{
    // document.querySelector('.cookies-alert-popup').style.display = 'none'
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.querySelector(".btn.preferencePrivacy-popup--closeBtn").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.add("show");
// document.cookie = '_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC'
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
document.querySelector(".btn.cookies-learn-more-btn").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupEl.classList.add("show");
    document.querySelector(".cookies-alert-popup").style.display = "none";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.preferencePrivacy-popupDetail--closeBtn").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--preferencePrivacy-popupDetailConfirmPreference").addEventListener("click", ()=>{
    $dd8a52bd9dba4c43$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});

});

var $5da24aefa08a25bc$exports = {};

(parcelRequire("3ueMA")).register(new URL("", import.meta.url).toString(), JSON.parse('["6j7oG","index.5f81db36.js","6caN2","battery-charging.ba1b1745.webp","cXG1D","settings-02.d69d69bd.webp","a8sKm","life-buoy.285e728c.webp","bjrUj","people.d532b8d6.webp","fkH4J","grid.f0e29351.webp","83Igj","box.2a34708a.webp","9Y1lA","testimoni-neo-mobile.63e4b5d3.webp","8KDDW","testimoni-neo.dcffeccd.webp","cWSbq","smashing-plates.7136aa41.webp","cMUme","testimoni-johny-mobile.dfee8b00.webp","k6JM1","testimoni-johny.331dada6.webp","57Uq8","luca-company.ebbca258.webp","iwFLi","testimonial-wonchul-mobile.82623782.webp","5rJO0","testimonial-wonchul.e435ed72.webp","n2loJ","sollip-company.c4e68d8a.png","59kaK","testimonial-george-mobile.ba4357c1.webp","3hhKd","testimonial-george.3f5b8295.webp","7Epdw","lio-company.51d21251.png","gNGks","testimonial-dominic-hamdy-mobile.795bc261.webp","vbdTF","testimonial-dominic-hamdy.7a029c2b.webp","8oJQA","ham-company.5f8ce858.png","9K1jB","testimonial-david-bellaiche-mobile.c3669d3d.webp","hOqIG","testimonial-david-bellaiche.e487dcaf.webp","15Hx9","nac-company.269e0029.png","jXZmL","testimonial-gabriel-mobile.45a97971.webp","1H8PE","testimonial-gabriel.ad41ee07.webp","7jDMh","creme-company.ca71e074.png"]'));

parcelRequire("1VgMz");
parcelRequire("eZzoa");
parcelRequire("lAems");
parcelRequire("j1fKb");
const $66554e51c7aeefbb$var$jsonLdData = `
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Wenodo Hospitality Accountants",
  "alternateName": "Wenodo",
  "url": "https://www.wenodo.com",
  "logo": "https://www.wenodo.com/app-logo.a6333df9.png",
  "contactPoint": [{
    "@type": "ContactPoint",
    "telephone": "+44 20 8037 7768",
    "contactType": "customer service",
    "areaServed": "GB"
  },{
    "@type": "ContactPoint",
    "telephone": "+971 54 320 9768",
    "contactType": "customer service",
    "areaServed": "AE"
  }],
  "sameAs": [
    "https://www.instagram.com/wenodo_ltd",
    "https://www.linkedin.com/company/wenodo",
    "https://x.com/WenodoLTD",
    "https://www.facebook.com/people/Wenodo/61555965042636/?mibextid=LQQJ4d"
  ]
}

{
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Wenodo Hospitality Accountants-London",
  "image": "https://www.wenodo.com/app-logo.a6333df9.png",
  "@id": "",
  "url": "https://www.wenodo.com",
  "telephone": "+44 20 8037 7768",
  "address": {
	"@type": "PostalAddress",
	"streetAddress": "Garden Suite, 96 Brighton Rd",
	"addressLocality": "Brighton",
	"postalCode": "SM7 1BU",
	"addressCountry": "GB"
  },
  "openingHoursSpecification": [
	{
  	"@type": "OpeningHoursSpecification",
  	"dayOfWeek": [
    	"Monday"
  	],
  	"opens": "08:00",
  	"closes": "18:00"
	},
	{
  	"@type": "OpeningHoursSpecification",
  	"dayOfWeek": [
    	"Tuesday"
  	],
  	"opens": "08:00",
  	"closes": "18:00"
	},
	{
  	"@type": "OpeningHoursSpecification",
  	"dayOfWeek": [
    	"Wednesday"
  	],
  	"opens": "08:00",
  	"closes": "18:00"
	},
	{
  	"@type": "OpeningHoursSpecification",
  	"dayOfWeek": [
    	"Thursday"
  	],
  	"opens": "11:00",
  	"closes": "18:00"
	},
	{
  	"@type": "OpeningHoursSpecification",
  	"dayOfWeek": [
    	"Friday"
  	],
  	"opens": "11:00",
  	"closes": "18:00"
	}
  ]
}


  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Wenodo Hospitality Accountants-Dubai",
  "image": "https://www.wenodo.com/app-logo.a6333df9.png",
  "@id": "",
  "url": "https://www.wenodo.com",
  "telephone": "+971 54 320 9768",
  "address": {
	"@type": "PostalAddress",
	"streetAddress": "WARBA CENTER, 2010 Business Center - Al Muraqqabat",
	"addressLocality": "Dubai",
	"postalCode": "",
	"addressCountry": ""
  },
  "openingHoursSpecification": [
	{
  	"@type": "OpeningHoursSpecification",
  	"dayOfWeek": [
    	"Monday"
  	],
  	"opens": "09:00",
  	"closes": "18:00"
	},
	{
  	"@type": "OpeningHoursSpecification",
  	"dayOfWeek": [
    	"Tuesday"
  	],
  	"opens": "09:00",
  	"closes": "18:00"
	},
	{
  	"@type": "OpeningHoursSpecification",
  	"dayOfWeek": [
    	"Wednesday"
  	],
  	"opens": "09:00",
  	"closes": "18:00"
	},
	{
  	"@type": "OpeningHoursSpecification",
  	"dayOfWeek": [
    	"Thursday"
  	],
  	"opens": "09:00",
  	"closes": "18:00"
	},
	{
  	"@type": "OpeningHoursSpecification",
  	"dayOfWeek": [
    	"Friday"
  	],
  	"opens": "09:00",
  	"closes": "18:00"
	}
  ]
}
{
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "Wenodo : Hospitality Accounting & Software Solutions",
    "item": "https://www.wenodo.com/"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "Wenodo Hospitality Accountants",
    "item": "https://www.wenodo.com/intelligent-finance"  
  },{
    "@type": "ListItem", 
    "position": 3, 
    "name": "Manage Payroll Services",
    "item": "https://www.wenodo.com/manage-payroll"  
  },{
    "@type": "ListItem", 
    "position": 4, 
    "name": "Hospitality Consulting Services",
    "item": "https://www.wenodo.com/consulting"  
  },{
    "@type": "ListItem", 
    "position": 5, 
    "name": "People Management Software",
    "item": "https://www.wenodo.com/people-management"  
  },{
    "@type": "ListItem", 
    "position": 6, 
    "name": "Power Insights for Hospitality Business",
    "item": "https://www.wenodo.com/power-insight"  
  },{
    "@type": "ListItem", 
    "position": 7, 
    "name": "Book a Demo",
    "item": "https://www.wenodo.com/book-a-demo"  
  },{
    "@type": "ListItem", 
    "position": 8, 
    "name": "Contact-us",
    "item": "https://www.wenodo.com/contact-us"  
  },{
    "@type": "ListItem", 
    "position": 9, 
    "name": "Blog",
    "item": "https://www.wenodo.com/blog"  
  }]
}

`;
const $66554e51c7aeefbb$var$scriptTag = document.createElement("script");
$66554e51c7aeefbb$var$scriptTag.type = "application/ld+json";
$66554e51c7aeefbb$var$scriptTag.textContent = $66554e51c7aeefbb$var$jsonLdData;
document.head.appendChild($66554e51c7aeefbb$var$scriptTag);


/* eslint-disable no-undef */ // import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs'
const $96d168488be61f01$var$rectangleBottomBorderTransformBusiness = `<svg
class="transformBusiness__rectangle-bottom"
width="100%"
height="auto"
viewBox="0 0 1440 54"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<path d="M1440 1L0 53" stroke="#E2E8F0" />
</svg>`;
document.querySelector(".transformBusiness").innerHTML += $96d168488be61f01$var$rectangleBottomBorderTransformBusiness;
const $96d168488be61f01$var$rectangleBottomTestimonial = `<svg class="testimonial__bg-rectangle-bottom" width="100%" height="100%" viewBox="0 0 1440 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_2239_14618" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1440" height="52">
  <path d="M1440 52L0 51.9999L1440 0L1440 52Z" fill="#1E2432" />
</mask>
<g mask="url(#mask0_2239_14618)">
  <rect x="-9" width="1458" height="879" fill="white" />
</g>
</svg>`;
document.querySelector(".section__testimonial").innerHTML += $96d168488be61f01$var$rectangleBottomTestimonial;
const $96d168488be61f01$var$arrowUpRightIcon = `<svg
width="20"
height="20"
viewBox="0 0 20 20"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<path
  d="M5.8335 14.1666L14.1668 5.83325M14.1668 5.83325H5.8335M14.1668 5.83325V14.1666"
  stroke="#05A6F0"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
/>
</svg>`;
document.querySelectorAll(".btn-talk-us").forEach((el)=>{
    el.innerHTML += $96d168488be61f01$var$arrowUpRightIcon;
    el.setAttribute("onclick", "location.href = 'contact-us.html';");
});
document.querySelectorAll(".btn-cta-product").forEach((el)=>{
    el.innerHTML += $96d168488be61f01$var$arrowUpRightIcon;
});
document.querySelectorAll(".btn-product-growth").forEach((el)=>{
    el.innerHTML += $96d168488be61f01$var$arrowUpRightIcon;
});
document.querySelector(".btn-product-testimonial").innerHTML += $96d168488be61f01$var$arrowUpRightIcon;
document.querySelector(".btn-product-about-us").innerHTML += $96d168488be61f01$var$arrowUpRightIcon;
document.querySelector(".btn-see-all-product").innerHTML += $96d168488be61f01$var$arrowUpRightIcon;
// document.querySelector('.btn-learn-more').innerHTML += arrowUpRightIcon
document.querySelector(".btn-book-demo__home").innerHTML += $96d168488be61f01$var$arrowUpRightIcon;
document.querySelectorAll(".information-map__contact-btn").forEach((el)=>{
    el.innerHTML += $96d168488be61f01$var$arrowUpRightIcon;
});
const $96d168488be61f01$var$preHeadingServiceIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="#1DCA5D" />
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8332 14.2284C13.2709 13.8584 14.3332 12.5533 14.3332 11.0001C14.3332 9.15913 12.8408 7.66675 10.9998 7.66675C9.15889 7.66675 7.6665 9.15913 7.6665 11.0001C7.6665 12.5533 8.72881 13.8584 10.1665 14.2284V23.5001C10.1665 23.9603 10.5396 24.3334 10.9998 24.3334C11.4601 24.3334 11.8332 23.9603 11.8332 23.5001V14.2284Z" fill="white" />
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6665 21.0001C17.6665 19.4469 18.7288 18.1418 20.1665 17.7718V12.6667C20.1665 12.4457 20.0787 12.2338 19.9224 12.0775C19.7661 11.9212 19.5542 11.8334 19.3332 11.8334H16.8332C16.3729 11.8334 15.9998 11.4603 15.9998 11.0001C15.9998 10.5398 16.3729 10.1667 16.8332 10.1667H19.3332C19.9962 10.1667 20.6321 10.4301 21.1009 10.899C21.5698 11.3678 21.8332 12.0037 21.8332 12.6667V17.7718C23.2709 18.1418 24.3332 19.4469 24.3332 21.0001C24.3332 22.841 22.8408 24.3334 20.9998 24.3334C19.1589 24.3334 17.6665 22.841 17.6665 21.0001Z" fill="white" />
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21.0001C17.6667 19.4469 18.729 18.1418 20.1667 17.7718V12.6667C20.1667 12.4457 20.0789 12.2338 19.9226 12.0775C19.7663 11.9212 19.5543 11.8334 19.3333 11.8334H16.8333C16.3731 11.8334 16 11.4603 16 11.0001C16 10.5398 16.3731 10.1667 16.8333 10.1667H19.3333C19.9964 10.1667 20.6323 10.4301 21.1011 10.899C21.5699 11.3678 21.8333 12.0037 21.8333 12.6667V17.7718C23.271 18.1418 24.3333 19.4469 24.3333 21.0001C24.3333 22.841 22.8409 24.3334 21 24.3334C19.1591 24.3334 17.6667 22.841 17.6667 21.0001Z" fill="#77DF9E" />
</svg>`;
document.querySelectorAll(".services__preHeading .services__icon").forEach((el)=>{
    el.innerHTML += $96d168488be61f01$var$preHeadingServiceIcon;
});
document.querySelector(".transformBusiness__preHeading-icon").innerHTML += $96d168488be61f01$var$preHeadingServiceIcon;
document.querySelector(".product__preHeading .services__icon").innerHTML += $96d168488be61f01$var$preHeadingServiceIcon;
document.querySelector(".testimonial-slider-preHeading .services__icon").innerHTML += $96d168488be61f01$var$preHeadingServiceIcon;
document.querySelector(".seamless-integration__preHeading .preHeadingIcon").innerHTML += $96d168488be61f01$var$preHeadingServiceIcon;
const $96d168488be61f01$var$servicesListItemIcon = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.6668 3.5L5.25016 9.91667L2.3335 7" stroke="#1E2432" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
document.querySelectorAll(".services__list-item-icon").forEach((el)=>{
    el.innerHTML += $96d168488be61f01$var$servicesListItemIcon;
});
const $96d168488be61f01$var$customerStoryContentBg = `<svg width="100%" height="100%" viewBox="0 0 996 237" fill="none" class="customer-story__content-bg large" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
  <path d="M0 51.5277C0 45.0877 5.08356 39.7958 11.5185 39.5374L996 0V237H0V51.5277Z" fill="#1E2432"/>
</svg>`;
const $96d168488be61f01$var$customStoryContentBgMobile = `<svg width="100%" height="100%" viewBox="0 0 327 316" fill="none" class="customer-story__content-bg small" xmlns="http://www.w3.org/2000/svg">
<path d="M0 19.801L327 0V316H0V19.801Z" fill="#1E2432"/>
</svg>
`;
document.querySelector(".js-customer-story__content-bg").innerHTML += $96d168488be61f01$var$customerStoryContentBg;
document.querySelector(".js-customer-story__content-bg").innerHTML += $96d168488be61f01$var$customStoryContentBgMobile;
const $96d168488be61f01$var$customerStoryContentQuote = `<svg class="customer-story-content-quote" width="129" height="106" viewBox="0 0 129 106" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M31.5528 100.408L33.082 101.603C39.642 96.4754 45.6415 87.5784 50.1383 77.3158C54.6425 67.0361 57.6861 55.2798 58.2597 44.3428C58.8321 33.4304 56.9513 23.1835 51.4305 16.0776C45.8535 8.89921 36.7219 5.12449 23.291 6.87312C9.97101 8.60731 -1.20758 22.1227 1.90096 35.9014C3.42636 42.6629 6.73531 47.897 11.486 51.2858C16.1257 54.5953 22.053 56.0827 28.8403 55.6095C31.3989 58.2953 34.8558 62.8601 36.3839 69.829C37.976 77.0894 37.4988 87.0709 31.5528 100.408ZM86.1274 99.006L87.4636 100.416C94.7392 96.2706 102.223 88.0993 108.521 78.2625C114.831 68.4075 120.017 56.7779 122.639 45.6107C125.253 34.4726 125.353 23.637 121.282 15.4907C117.16 7.24188 108.883 1.97667 95.3218 1.8041C81.8971 1.63326 68.7638 13.4199 69.695 27.4942C70.1522 34.4039 72.6092 40.0582 76.7811 44.0904C80.8527 48.0255 86.477 50.3378 93.2507 50.8332C97.3181 56.9567 101.697 74.7873 86.1274 99.006Z" fill="#F3A515" stroke="white" stroke-width="2"/>
</svg>`;
document.querySelector(".js-customer-story-content-quote").innerHTML += $96d168488be61f01$var$customerStoryContentQuote;
const $96d168488be61f01$var$chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".link-item .arrow-down").forEach((el)=>{
    el.innerHTML += $96d168488be61f01$var$chevronDownIcon;
});
const $96d168488be61f01$var$hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelector(".btn-hamburger").innerHTML += $96d168488be61f01$var$hamburgerIcon;
const $96d168488be61f01$var$rectangleBottomProductGrowth = `<svg width="100%" height="auto" viewBox="0 0 1440 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1440 52L0 51.9999L1440 0L1440 52Z" fill="white"/>
</svg>`;
document.querySelector(".rectangleBottonProductGrow").innerHTML += $96d168488be61f01$var$rectangleBottomProductGrowth;
const $96d168488be61f01$var$rectangleTopFinancialExpert = `<svg width="100%" height="auto" viewBox="0 0 1440 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0H1440L0 52V0Z" fill="white"/>
</svg>
`;
document.querySelector(".financial-feature-section__rectangle-top").innerHTML += $96d168488be61f01$var$rectangleTopFinancialExpert;
const $96d168488be61f01$var$featureSectionEl = document.querySelector(".feature-section");
$96d168488be61f01$var$featureSectionEl.querySelectorAll(".tab-feature").forEach((tabElement)=>{
    tabElement.addEventListener("click", ()=>{
        $96d168488be61f01$var$featureSectionEl.querySelectorAll(".tab-feature").forEach((el)=>{
            el.classList.remove("active");
        });
        $96d168488be61f01$var$featureSectionEl.querySelectorAll(".features__illustration img").forEach((el)=>{
            el.style.display = "none";
            if (tabElement.getAttribute("data-tab") === el.getAttribute("data-tab")) el.style.display = "block";
        });
        $96d168488be61f01$var$featureSectionEl.querySelectorAll(".feature-points").forEach((el)=>{
            el.style.display = "none";
            if (tabElement.getAttribute("data-tab") === el.getAttribute("data-tab")) el.style.display = "grid";
        });
        console.log(tabElement.getAttribute("data-tab"));
        tabElement.classList.add("active");
    });
});
const $96d168488be61f01$var$featurePointsDigitalTransformation = $96d168488be61f01$var$featureSectionEl.querySelector('.feature-points[data-tab="digital-transformation"]').cloneNode(true);
$96d168488be61f01$var$featureSectionEl.querySelector('.select-group-feature[data-tab="digital-transformation"]').querySelector(".feature-points-mobile").appendChild($96d168488be61f01$var$featurePointsDigitalTransformation);
const $96d168488be61f01$var$featurePointsIntelligentFinance = $96d168488be61f01$var$featureSectionEl.querySelector('.feature-points[data-tab="intelligent-finance"]').cloneNode(true);
$96d168488be61f01$var$featureSectionEl.querySelector('.select-group-feature[data-tab="intelligent-finance"]').querySelector(".feature-points-mobile").appendChild($96d168488be61f01$var$featurePointsIntelligentFinance);
const $96d168488be61f01$var$featurePointsPeopleManagement = $96d168488be61f01$var$featureSectionEl.querySelector('.feature-points[data-tab="people-management"]').cloneNode(true);
$96d168488be61f01$var$featureSectionEl.querySelector('.select-group-feature[data-tab="people-management"]').querySelector(".feature-points-mobile").appendChild($96d168488be61f01$var$featurePointsPeopleManagement);
const $96d168488be61f01$var$featurePointsAnalytics = $96d168488be61f01$var$featureSectionEl.querySelector('.feature-points[data-tab="analytics"]').cloneNode(true);
$96d168488be61f01$var$featureSectionEl.querySelector('.select-group-feature[data-tab="analytics"]').querySelector(".feature-points-mobile").appendChild($96d168488be61f01$var$featurePointsAnalytics);
$96d168488be61f01$var$featureSectionEl.querySelectorAll(".select-group-feature").forEach((selectElement)=>{
    selectElement.addEventListener("click", ()=>{
        if (selectElement.classList.contains("active")) {
            selectElement.classList.remove("active");
            selectElement.querySelector(".select-feature-content").style.display = "none";
            selectElement.querySelector(".feature-points").style.display = "none";
        } else {
            $96d168488be61f01$var$featureSectionEl.querySelectorAll(".select-group-feature").forEach((el)=>{
                el.querySelector(".select-feature-content").style.display = "none";
                el.classList.remove("active");
            });
            selectElement.classList.add("active");
            selectElement.querySelector(".select-feature-content").style.display = "block";
            selectElement.querySelector(".feature-points").style.display = "grid";
        }
    });
});
// Create the observer like the examples above
const $96d168488be61f01$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) entry.target.classList.add("animate__fadeInUp");
    // entry.target.classList.remove('animate__animated')
    });
});
// Get multiple elements instead of a single one using "querySelectorAll"
const $96d168488be61f01$var$squares = document.querySelectorAll(".animated-js");
// Loop over the elements and add each one to the observer
$96d168488be61f01$var$squares.forEach((element)=>$96d168488be61f01$var$observer.observe(element));
// eslint-disable-next-line no-unused-vars
const $96d168488be61f01$var$swiper = new Swiper(".swiper-testimonial", {
    // Optional parameters
    // direction: 'vertical',
    loop: false,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 32,
    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination'
    // },
    // Navigation arrows
    navigation: {
        nextEl: ".swiper-testimonial-next-button",
        prevEl: ".swiper-testimonial-prev-button"
    },
    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar'
    // }
    breakpoints: {
        1200: {
            slidesPerView: 1.2
        }
    }
});
// eslint-disable-next-line no-unused-vars
const $96d168488be61f01$var$swiperSeamlessIntegration = new Swiper(".swiperSeamlessIntegration", {
    loop: true,
    spaceBetween: 300,
    navigation: {
        nextEl: ".swiper-seamless-integration-button-next",
        prevEl: ".swiper-seamless-integration-button-prev"
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    }
});
// eslint-disable-next-line no-unused-vars
const $96d168488be61f01$var$swiperClientLogos = new Swiper(".swiper-client-logos", {
    loop: true,
    autoplay: true
});
const $96d168488be61f01$var$isLarge = window.matchMedia("(min-width: 1200px)");
if ($96d168488be61f01$var$isLarge.matches) // Then trigger an alert
$96d168488be61f01$var$swiper.on("slideChange", function() {
    if ($96d168488be61f01$var$swiper.activeIndex === 0) document.querySelector(".swiper-wrapper.testimonial-cards").style.left = "-8.25%";
    else if ($96d168488be61f01$var$swiper.activeIndex === 1) {
        document.querySelector(".swiper-wrapper.testimonial-cards").style.left = "auto";
        document.querySelector(".swiper-wrapper.testimonial-cards").style.right = "auto";
    } else if ($96d168488be61f01$var$swiper.activeIndex === 2) document.querySelector(".swiper-wrapper.testimonial-cards").style.right = "-8.25%";
});


//# sourceMappingURL=index.5f81db36.js.map
